import { render, staticRenderFns } from "./ProjectListItem.vue?vue&type=template&id=5bf0a443"
import script from "./ProjectListItem.vue?vue&type=script&lang=js"
export * from "./ProjectListItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectListItem.vue?vue&type=style&index=0&id=5bf0a443&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports